import * as actionTypes from '../actions/actionTypes';

const initialState = {
    data: null,
    loading: null,
    error: null
};

const reducer = (state = initialState, action) => {
    switch(action.type){
        case actionTypes.SEND_MESSAGE_INITIALIZE:
            return {
                ...state,
                loading: null,
                error: null,
                data: null
            };
        case actionTypes.SEND_MESSAGE_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
                data: null
            };
        case actionTypes.SEND_MESSAGE_FAIL:
            return {
                ...state,
                loading: false,
                error: action.error,
                data: null
            };
        case actionTypes.SEND_MESSAGE_SUCCESS:
            return {
                ...state,
                loading: false,
                error: false,
                data: action.payload
            };
        default:
            return state;
    }
};

export default reducer;